import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { WatchlistAddTickerDialogComponent } from '../../../../features/watchlist/dialogs/add-ticker-dialog/watchlist-add-ticker-dialog.component';
import { WatchlistService } from '../../../../core/services/watchlist.service';
import { Tooltip } from "primeng/tooltip";
import { FeatureAccessDirective } from '../../../directives/feature-access.directive';

@Component({
  selector: 'app-watchlist-add-button',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SplitButtonModule,
    WatchlistAddTickerDialogComponent,
    Tooltip,
    FeatureAccessDirective
],
  templateUrl: './watchlist-add-button.component.html',
  styleUrls: ['./watchlist-add-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WatchlistAddButtonComponent implements OnInit {
  @ViewChild(WatchlistAddTickerDialogComponent)
  addTickerDialog?: WatchlistAddTickerDialogComponent;

  private watchlistService = inject(WatchlistService);

  // Input
  ticker = input.required<string>();
  showCount = input<boolean>(true);
  watchlistCount = signal(0);
  watchlistNames = signal<string[]>([]);

  ngOnInit(): void {
    this.getWatchlistCount();
  }

  getWatchlistCount() {
    this.watchlistService.getWatchlistsForTicker(this.ticker()).subscribe((lists) => {
      const safeLists = lists ?? [];
      this.watchlistCount.set(safeLists.length);
      this.watchlistNames.set(safeLists.map(w => w.name));
    });
  }
  // Menu items for split button
  menuItems = [
    {
      label: 'Add to Watchlist',
      icon: 'pi pi-bookmark',
      command: () => this.openAddDialog(),
    },
  ];

  /**
   * Open the add ticker to watchlist dialog
   */
  openAddDialog(): void {
    this.addTickerDialog?.show(this.ticker());
  }

  /**
   * Handle ticker added event
   */
  onTickerAdded(): void {
    this.getWatchlistCount();
  }
}
